import { showDialog, showConfirmDialog } from "vant";
import { getPrimaryColor } from "@/utils/cssVars";
const autoDialog = (message, opts = {}, autoCloseMs = 1500) => {
    const promise = showDialog({
        message,
        confirmButtonText: "\u77E5\u9053\u4E86",
        confirmButtonColor: getPrimaryColor(),
        closeOnClickOverlay: true,
        ...opts
    });
    if (autoCloseMs > 0) {
        const timer = setTimeout(() => {
            try {
                const btn = document.querySelector(".van-dialog .van-dialog__confirm");
                if (btn)
                    btn.click();
            }
            catch (_) {
            }
        }, autoCloseMs);
        promise.finally(() => clearTimeout(timer));
    }
    return promise;
};
export const showMsg = (message) => {
    return autoDialog(message, {
        confirmButtonText: "\u597D\u7684",
        confirmButtonColor: getPrimaryColor()
    }, 1500);
};
export const showErr = (message) => {
    return showDialog({
        title: "\u63D0\u793A",
        message,
        confirmButtonText: "\u77E5\u9053\u4E86",
        confirmButtonColor: "#ee0a24"
    });
};
export const showOk = (message) => {
    return autoDialog(message, {
        confirmButtonText: "\u2713",
        confirmButtonColor: "#07c160"
    }, 1200);
};
export const showWarn = (message) => {
    return showDialog({
        title: "\u6CE8\u610F",
        message,
        confirmButtonText: "\u6211\u77E5\u9053\u4E86",
        confirmButtonColor: "#ed6a0c"
    });
};
export const showConfirm = (title, message, opts = {}) => {
    return showConfirmDialog({
        title,
        message,
        confirmButtonText: "\u786E\u8BA4",
        cancelButtonText: "\u53D6\u6D88",
        confirmButtonColor: getPrimaryColor(),
        ...opts
    });
};
export const showLoading = (message = "\u52A0\u8F7D\u4E2D...") => {
    const wrapper = document.createElement("div");
    wrapper.className = "g-loading-overlay";
    wrapper.innerHTML = `
    <div class="g-loading-card">
      <div class="g-loading-spinner"></div>
      <div class="g-loading-text">${message}</div>
    </div>
  `;
    document.body.appendChild(wrapper);
    const setText = (newMsg) => {
        const el = wrapper.querySelector(".g-loading-text");
        if (el)
            el.textContent = newMsg;
    };
    const close = () => {
        try {
            document.body.removeChild(wrapper);
        }
        catch (_) {
        }
    };
    return { close, setText };
};
export default { showMsg, showErr, showOk, showWarn, showConfirm, showLoading };
